// ======================================================
// Afrihair Bulk "Add to Cart" - Mirroring & Smart Lock (Klaviyo Ready)
// ======================================================
(function(){

  function getForm(){
    return document.querySelector('product-form form[action^="/cart/add"]')
        || document.querySelector('form[action^="/cart/add"]');
  }

  function setQuantities(form, qty){
    qty = Math.max(1, parseInt(qty || '1', 10));
    const targets = [];
    targets.push(...form.querySelectorAll('input[name="quantity"]'));
    if (form.id) {
      targets.push(...document.querySelectorAll(`input[name="quantity"][form="${form.id}"]`));
    }
    if (!targets.length){
      const hidden = document.createElement('input');
      hidden.type  = 'hidden';
      hidden.name  = 'quantity';
      hidden.value = qty;
      form.appendChild(hidden);
      targets.push(hidden);
    }
    targets.forEach(el => {
      el.value = qty;
      el.dispatchEvent(new Event('change', { bubbles:true }));
    });
  }

  function clickNativeSubmit(form){
    const btn = form.querySelector('button[name="add"], .product-form__submit, button[type="submit"]');
    if (btn) {
      btn.dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true }));
    } else if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function resolveQtyFromButton(hit){
    if (hit.dataset.qty && !hit.hasAttribute('data-qty-source')) {
      return Math.max(1, parseInt(hit.dataset.qty, 10) || 1);
    }
    const srcSel = hit.getAttribute('data-qty-source');
    if (srcSel) {
      const src = document.querySelector(srcSel);
      return Math.max(1, parseInt(src && src.value, 10) || 1);
    }
    const raw = hit.dataset.qty || hit.textContent || '1';
    const m   = String(raw).match(/\d+/);
    return Math.max(1, parseInt(m ? m[0] : '1', 10));
  }

  // --------------------------------------------------------
  // LOGIC A: Variant "Driver"
  // --------------------------------------------------------
  function initVariantDriver() {
    const topSelect = document.getElementById('afri-micro-variant-select');
    if (!topSelect) return;

    topSelect.addEventListener('change', function(){
      const opt = topSelect.options[topSelect.selectedIndex];
      const val1 = opt.getAttribute('data-option1');
      const val2 = opt.getAttribute('data-option2');
      const val3 = opt.getAttribute('data-option3');
      const variantId = topSelect.value;

      // FREEZE
      const x = window.scrollX;
      const y = window.scrollY;

      const originalFocus = HTMLElement.prototype.focus;
      const originalScroll = window.scroll;
      const originalScrollTo = window.scrollTo;
      const originalScrollIntoView = Element.prototype.scrollIntoView;

      HTMLElement.prototype.focus = function(){ return false; };
      window.scroll = function(){ return false; };
      window.scrollTo = function(){ return false; };
      Element.prototype.scrollIntoView = function(){ return false; };

      // TRIGGER
      const container = document.body;
      const triggerOption = (val, index) => {
        if (!val) return;
        let radio = container.querySelector(`fieldset input[value="${val.replace(/"/g, '\\"')}"]`);
        if (radio) {
             radio.checked = true;
             radio.dispatchEvent(new Event('change', { bubbles: true }));
             return;
        }
        const selects = container.querySelectorAll('variant-selects select, .product-form__input select');
        if (selects[index]) {
          selects[index].value = val;
          selects[index].dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      triggerOption(val1, 0);
      triggerOption(val2, 1);
      triggerOption(val3, 2);

      const form = getForm();
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = variantId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // RESTORE
      setTimeout(() => {
        HTMLElement.prototype.focus = originalFocus;
        window.scroll = originalScroll;
        window.scrollTo = originalScrollTo;
        Element.prototype.scrollIntoView = originalScrollIntoView;
        if (originalScrollTo) originalScrollTo.call(window, x, y);
      }, 2500); 
    });
  }


  // --------------------------------------------------------
  // LOGIC B: Handle Click (Add-To-Cart OR Klaviyo)
  // --------------------------------------------------------
  document.addEventListener('click', function(e){
    const hit = e.target.closest('.afri-bulk');
    if (!hit) return; 
    if (hit.tagName === 'A') e.preventDefault();

    const form = getForm();
    if (!form) return; 

    const mainBtn = form.querySelector('button[name="add"], .product-form__submit, button[type="submit"]');
    const mainText = mainBtn ? mainBtn.textContent.toLowerCase() : '';
    
    // --- KLAVIYO HANDLER ---
    // If the button is disabled, sold out, or notify me, we need to find the trigger
    const isSpecial = mainBtn && (mainBtn.disabled || mainText.includes('sold') || mainText.includes('notify') || mainText.includes('contact'));
    
    if (isSpecial) {
      // 1. Look for the Klaviyo specific trigger class (standard implementation)
      const klaviyoTrigger = document.querySelector('.klaviyo-bis-trigger, #klaviyo-bis-trigger');
      if (klaviyoTrigger) {
        klaviyoTrigger.click();
        return;
      }

      // 2. If no specific trigger, click the main button (standard fallback)
      if (mainBtn) mainBtn.click();
      return;
    }

    // --- STANDARD ADD TO CART ---
    const qty = resolveQtyFromButton(hit);
    hit.classList.add('afri-is-loading'); 
    hit.disabled = true; 
    hit.textContent = 'Adding...';

    setQuantities(form, qty);
    clickNativeSubmit(form);

    setTimeout(function(){
      hit.classList.remove('afri-is-loading'); 
      hit.disabled = false;
      if (window.AfriSyncState) window.AfriSyncState(); 
    }, 2000); 
  });


  // --------------------------------------------------------
  // LOGIC C: Mirror Main Button State
  // --------------------------------------------------------
  function initMirroring() {
    const microBtn = document.getElementById('afri-micro-btn');
    const microQty = document.getElementById('afri-micro-qty');
    const form = getForm();
    if (!microBtn || !form) return;

    const mainBtn = form.querySelector('button[name="add"], .product-form__submit, button[type="submit"]');
    if (!mainBtn) return;

    window.AfriSyncState = () => {
      if (microBtn.classList.contains('afri-is-loading')) return;
      
      const mainText = (mainBtn.textContent || '').trim();
      const lowerText = mainText.toLowerCase();

      // Check specifically for Klaviyo injected text or standard sold out
      const isSoldOut = lowerText.includes('sold') || lowerText.includes('out of stock');
      const isNotify  = lowerText.includes('notify') || lowerText.includes('back in stock');
      const isUnavailable = lowerText.includes('unavailable');
      
      // We ignore the fact that the main button is hidden via CSS
      
      if (isSoldOut || isNotify || isUnavailable) {
        // Copy the text exactly (e.g. "Notify me when available")
        microBtn.textContent = mainText;
        microBtn.style.opacity = '0.6';
        microBtn.disabled = false; // Keep clickable so it triggers the Klaviyo logic above
      } else {
        const currentQty = microQty ? (microQty.value || '1') : '1';
        microBtn.textContent = `Add ${currentQty} to Cart`;
        microBtn.style.opacity = '1';
        microBtn.disabled = false;
      }
    };

    const observer = new MutationObserver(window.AfriSyncState);
    observer.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });

    if (microQty) {
      microQty.addEventListener('input', window.AfriSyncState);
      microQty.addEventListener('change', window.AfriSyncState);
    }
    window.AfriSyncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      initVariantDriver();
      initMirroring();
    });
  } else {
    initVariantDriver();
    initMirroring();
  }
})();